// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Pakistan from '../_raw/flag/icon_flag_pakistan.png';

export default () => <img src={Pakistan} alt="Pakistan" />;
